export enum Entities {
  RootCategoryId = 'root',
}
